import './ExteriorButton.css';
import { Pill } from '../../components/Pill';
import { t } from '../../copy/strings';
import { navigate, openPlace } from '../../state/actions';
import { useConfig, useIsAbroad, useStatics, useTvOn } from '../../state/hooks';

/** Liga: Exterior (força Presidente; mantém `mapa`, `cand` e `t`). Desliga: Presidente · Brasil (§6.6 bloco 5). */
export function toggleAbroad(on: boolean): void {
  if (on) openPlace({ kind: 'abroad' });
  else navigate({ office: 'president', place: { kind: 'br' } });
}

/**
 * Pílula "Exterior" (§6.6): `Pill` com `aria-pressed` em qualquer nível do Exterior; o nome acessível é fixo
 * ("Exterior") e a dica fica no `title`. Oculta sem `features.abroad`, antes de a Geography chegar, sem cidades no
 * exterior e na TV. O TopBar só a monta a partir da Fase 10 (§17.2 Fase 2b item 5).
 */
export function ExteriorButton() {
  const flags = useConfig().features;
  const geo = useStatics().geography;
  const tv = useTvOn();
  const on = useIsAbroad();
  if (!flags.abroad || !geo || geo.abroad_cities.length === 0 || tv) return null;
  return (
    <span class="exterior-button" data-testid="exterior-button">
      <Pill
        label={t('exterior.button')}
        icon="globe"
        pressed={on}
        title={t(on ? 'exterior.button.aria.on' : 'exterior.button.aria.off')}
        onToggle={toggleAbroad}
      />
    </span>
  );
}
